export default __webpack_public_path__ + "static/media/IMG_0036_1_11zon.65615edf.jpg";